import { MessageCircle } from "lucide-react";

export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/601172283321?text=Hello%20YC%20SYSTEM%2C%20I%20would%20like%20to%20enquire%20about%20your%20ELV%2FCCTV%2FSecurity%20Systems."
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-button"
      aria-label="Chat on WhatsApp"
      className="wa-pulse fixed bottom-6 right-6 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-2xl hover:scale-110 transition-transform flex items-center gap-2 font-bold"
    >
      <MessageCircle className="w-6 h-6" />
      <span className="hidden sm:inline text-sm pr-1">WhatsApp Us</span>
    </a>
  );
}
